<script lang="ts">
	import {
		addFundsToken,
		addFundsTokenAmount,
		withdrawFundsTokenAmount,
		withdrawToken
	} from '$lib/home/scwallet/store';
	import { nativeBalancesEnriched, userBalancesEnriched } from '$lib/home/store';
	import { getTokenLogo } from '$lib/tokensConfig';
	import type { TokenSymbol } from '$lib/types/tokens';
	import {
		getDecimalOfToken,
		getNumBackInUnits,
		getPrecisionOfToken,
		sanitizeInputs,
		toBN
	} from '$lib/util/util';
	import { MIN_ETH_BALANCE } from '$lib/web3/contants';
	import BigNumber from 'bignumber.js';
	import { ethers } from 'ethers';

	export let selectedToken: TokenSymbol = 'sUSD';
	export let componentType: 'Deposit' | 'Withdraw' = 'Deposit';
	let amountPercentage = [25, 50, 75, 100];
	let selected = 0;
	export let input: string = '';

	function inputChanged() {
		input = sanitizeInputs(input);
		if (componentType === 'Deposit') {
			if (input) {
				$addFundsTokenAmount = toBN(input, getDecimalOfToken($addFundsToken));
			} else $addFundsTokenAmount = toBN('0');
		}

		if (componentType === 'Withdraw') {
			input = sanitizeInputs(input);
			if (input) {
				$withdrawFundsTokenAmount = toBN(input, getDecimalOfToken($withdrawToken));
			} else $withdrawFundsTokenAmount = toBN('0');
		}
	}

	function setPercentage() {
		if (
			componentType === 'Deposit' &&
			$nativeBalancesEnriched &&
			$nativeBalancesEnriched[$addFundsToken]
		) {
			let adjusted =
				selectedToken === 'ETH'
					? new BigNumber($nativeBalancesEnriched[$addFundsToken].balance)
							.minus(toBN(MIN_ETH_BALANCE).toString())
							.multipliedBy(selected / 100)
					: new BigNumber($nativeBalancesEnriched[$addFundsToken].balance).multipliedBy(
							selected / 100
					  );
			$addFundsTokenAmount = adjusted.isGreaterThan(0)
				? ethers.BigNumber.from(adjusted.toFixed(0))
				: ethers.BigNumber.from('0');
			input = getNumBackInUnits(
				$addFundsTokenAmount.toString(),
				getDecimalOfToken($addFundsToken),
				getPrecisionOfToken($addFundsToken)
			);
			return;
		}

		if (
			componentType === 'Withdraw' &&
			$userBalancesEnriched &&
			$userBalancesEnriched[$withdrawToken]
		) {
			$withdrawFundsTokenAmount = ethers.BigNumber.from(
				new BigNumber($userBalancesEnriched[$withdrawToken].balance)
					.multipliedBy(selected / 100)
					.toFixed(0)
			);

			input = getNumBackInUnits(
				$withdrawFundsTokenAmount.toString(),
				getDecimalOfToken($withdrawToken),
				getPrecisionOfToken($withdrawToken)
			);
			return;
		}
	}

	$: if (componentType === 'Deposit') {
		$addFundsToken = selectedToken;
	} else {
		$withdrawToken = selectedToken;
	}
</script>

<div class="text-fx-grey-200 text-xs mt-4 mb-2">Amount:</div>

<div class="border-fx-grey-600 border bg-fx-grey-900 px-3 py-2 rounded-lg squircle-lg w-full">
	<div class="flex w-full justify-between">
		<input
			inputmode="decimal"
			autocomplete="off"
			autocorrect="off"
			minlength="1"
			maxlength="79"
			spellcheck="false"
			pattern="^[0-9]*[.,]?[0-9]*$"
			bind:value={input}
			on:input={inputChanged}
			type="string"
			placeholder="0"
			class="bg-transparent text-fx-grey-100 font-semibold outline-none text-base max-w-[130px]"
		/>
		<div class="flex items-center gap-1">
			<p class="text-fx-grey-400 text-xs">Balance:</p>
			<p class="text-fx-gradient-5 text-xs font-semibold">
				{#if $nativeBalancesEnriched && $nativeBalancesEnriched[$addFundsToken] && componentType === 'Deposit'}
					<span class="text-fx-grey-200 text-xs"
						>{getNumBackInUnits(
							$nativeBalancesEnriched[$addFundsToken].balance,
							getDecimalOfToken($addFundsToken),
							getPrecisionOfToken($addFundsToken)
						)}</span
					>
				{/if}

				{#if $userBalancesEnriched && $userBalancesEnriched[$withdrawToken] && componentType == 'Withdraw'}
					<span class="text-fx-grey-200 text-xs"
						>{getNumBackInUnits(
							$userBalancesEnriched[$withdrawToken].balance,
							getDecimalOfToken($withdrawToken),
							getPrecisionOfToken($withdrawToken)
						)}</span
					>
				{/if}
			</p>
			<img loading="lazy" src={getTokenLogo(selectedToken)} alt="usdc.svg" class="w-5 h-5" />
		</div>
	</div>

	<div class="border-t border-t-fx-grey-600 w-full my-2" />

	<div class="flex justify-between text-white">
		{#each amountPercentage as percent}
			{#if selected === percent}
				<button
					class="bg-fx-gradient-8 border-fx-grey-600 border rounded-lg squircle-lg text-fx-white text-xs w-20 h-8 text-center flex items-center justify-center"
					on:click={() => ((selected = percent), setPercentage())}
				>
					{percent === 100 ? 'Max' : percent + '%'}
				</button>
			{:else}
				<button
					class="bg-fx-grey-800 rounded-lg squircle-lg text-fx-grey-300 text-xs w-20 h-8 text-center flex items-center justify-center"
					on:click={() => ((selected = percent), setPercentage())}
				>
					{percent === 100 ? 'Max' : percent + '%'}
				</button>
			{/if}
		{/each}
	</div>
</div>
